// The callback's business belongs to the server-side OAuth attempt. Never replace it
// with the current business selection, including on reload or a route remount.
export const ADS_CLAIM_KEY = 'oauth_session_id';
export const ADS_CLAIM_CONTEXT_KEY = 'ads_oauth_claim_context';

export const adsClaimBusinessId = (value) => {
  if (!['string', 'number'].includes(typeof value) || !/^\d+$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function readAdsClaimContext(claimToken) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(ADS_CLAIM_CONTEXT_KEY) || 'null');
    if (
      !claimToken ||
      sessionStorage.getItem(ADS_CLAIM_KEY) !== claimToken ||
      stored?.claimToken !== claimToken
    )
      return null;
    const businessProfileId = adsClaimBusinessId(stored.businessProfileId);
    return businessProfileId ? { claimToken, businessProfileId } : null;
  } catch {
    return null;
  }
}

export function captureAdsClaimContext(claimToken, businessId) {
  if (typeof claimToken !== 'string' || !claimToken) return null;
  try {
    const existing = readAdsClaimContext(claimToken);
    sessionStorage.setItem(ADS_CLAIM_KEY, claimToken);
    // A later URL/global selection cannot retarget this token's recorded attempt.
    if (existing) return existing;
    const businessProfileId = adsClaimBusinessId(businessId);
    sessionStorage.removeItem(ADS_CLAIM_CONTEXT_KEY);
    if (!businessProfileId) return null;
    const context = { claimToken, businessProfileId };
    sessionStorage.setItem(ADS_CLAIM_CONTEXT_KEY, JSON.stringify(context));
    return readAdsClaimContext(claimToken);
  } catch {
    return null;
  }
}

export function clearAdsClaimContext(claimToken) {
  try {
    // A late response from an old component must never erase a newer attempt.
    if (sessionStorage.getItem(ADS_CLAIM_KEY) !== claimToken) return;
    sessionStorage.removeItem(ADS_CLAIM_KEY);
    sessionStorage.removeItem(ADS_CLAIM_CONTEXT_KEY);
  } catch {
    // The mounted page still discards its in-memory token.
  }
}

export function readAdsClaimToken() {
  try {
    return sessionStorage.getItem(ADS_CLAIM_KEY);
  } catch {
    return null;
  }
}
